import { cloneDeep } from "lodash";
import {
    UPDATE_CROSS_SECTIONAL_AREA_STARTING,
    UPDATE_CROSS_SECTIONAL_AREA_SUCCESS,
    UPDATE_CROSS_SECTIONAL_AREA_ERROR,    
} from "../../../constants/actionTypes";
import initialState from "../../../store/initialState";

export default function updateCrossSectionalAreaReducer(state = initialState.updateCrossSectionalArea, action) {
    switch (action.type) {
        case UPDATE_CROSS_SECTIONAL_AREA_STARTING: {
            const { crossSectionalAreaId } = action;
            const newState = cloneDeep(state);
            if (!newState[crossSectionalAreaId]) {
                newState[crossSectionalAreaId] = cloneDeep(initialState.updateCrossSectionalArea.crossSectionalAreaId);
            }
            const crossSectionalAreaData = newState[crossSectionalAreaId];
            crossSectionalAreaData.saving = true;
            crossSectionalAreaData.saved = false;
            crossSectionalAreaData.error = null;

            return newState;
        }
        case UPDATE_CROSS_SECTIONAL_AREA_SUCCESS: {
            const { crossSectionalAreaId } = action;
            const newState = cloneDeep(state);
            if (!newState[crossSectionalAreaId]) {
                newState[crossSectionalAreaId] = cloneDeep(initialState.updateCrossSectionalArea.crossSectionalAreaId);
            }

            const crossSectionalAreaData = newState[crossSectionalAreaId];
            crossSectionalAreaData.saving = false;
            crossSectionalAreaData.saved = true;
            crossSectionalAreaData.error = null;
            return newState;
        }

        case UPDATE_CROSS_SECTIONAL_AREA_ERROR: {
            const { crossSectionalAreaId } = action;
            const newState = cloneDeep(state);

            if (!newState[crossSectionalAreaId]) {
                newState[crossSectionalAreaId] = cloneDeep(initialState.updateCrossSectionalArea.crossSectionalAreaId);
            }

            const crossSectionalAreaData = newState[crossSectionalAreaId];
            crossSectionalAreaData.saving = false;
            crossSectionalAreaData.saved = false;
            crossSectionalAreaData.error = action.err;
            return newState;
        }
        default: {
            return state;
        }
    }
}